module.exports = __webpack_public_path__ + "img/evo_slot.763cbd9a.png";